import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import FetchMore from 'js/components/FetchMore'
import LoadingSpinner from 'js/components/LoadingSpinner/LoadingSpinner'
import VersionListItem from 'js/components/VersionHistory/VersionListItem'
import PageEditorContext from 'js/page/PageEditor/PageEditorContext'
import { PAGE_EDITOR_REVISIONS_PAGE_SIZE } from 'js/page/PageEditor/usePageEditorRevisions'

import styles from './PageEditorRevisionsList.module.css'

const PageEditorRevisionsList = () => {
    const { t } = useTranslation()
    const { pathname } = useLocation()

    const {
        pageRevisions: {
            versionParam,
            revisionsLoading,
            revisionEdges,
            revisionTotal,
            fetchMore,
            restoreRevision,
        },
    } = useContext(PageEditorContext)

    if (revisionsLoading) {
        return <LoadingSpinner />
    }

    if (!revisionEdges.length) {
        return null
    }

    return (
        <FetchMore
            as="ul"
            className={styles.list}
            edges={revisionEdges}
            getMoreResults={(data) => data.revisions.edges}
            fetchMore={fetchMore}
            fetchCount={PAGE_EDITOR_REVISIONS_PAGE_SIZE}
            maxLimit={revisionTotal}
            resultsMessage={t('global.result', {
                count: revisionTotal,
            })}
            fetchMoreButtonLabel={t('action.show-more-versions')}
            fetchMoreButtonSpacing="none"
            fetchMoreButtonRadius="none"
        >
            {revisionEdges.map((revision, i) => {
                const isLatest = i === 0
                const url = isLatest
                    ? pathname
                    : `${pathname}?v=${revision.guid}`

                return (
                    <VersionListItem
                        key={revision.guid}
                        revision={revision}
                        url={url}
                        isActive={
                            versionParam
                                ? versionParam === revision.guid
                                : isLatest
                        }
                        isLatest={isLatest}
                        onRestore={restoreRevision}
                    />
                )
            })}
        </FetchMore>
    )
}

export default PageEditorRevisionsList
